import { useBreakpointPreviewStore } from 'Modules/@apostrophecms/ui/stores/breakpointPreview.js';

export default function() {
  useBreakpointPreviewStore();
};
